import { useState, useEffect } from "react";
import ThemeMaker from "../../components/thememaker";
import axios from "axios";
import { toast } from "react-toastify";
import { useParams } from "react-router-dom";
import { tokenDecode } from "../../utils/helper";
import { config } from "../../utils/config";
import "../../index.css"
import brandStyles from "../Brand/Brand.module.css";
import "../../components/mcrbTableTheme.css";
const { apiEndpoint } = config;

// Field-format validators for email / phone number inputs
const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const PHONE_REGEX = /^[6-9]\d{9}$/; // 10-digit Indian mobile number
const EMAIL_ERROR_MSG = "Please enter a valid email address !";
const PHONE_ERROR_MSG = "Please enter a valid 10-digit phone number !";

interface ICustomer {
  id: any;
}
const AddUser = () => {
  let params: ICustomer = useParams();
  const { id } = params;
  const [pageNamem, setpageName] = useState(true);

  const [loading, setLoading] = useState(false);
  const [uploading, setUpLoading] = useState(false);
  const decode = tokenDecode();
  const [roleData, setRoleData] = useState([]);

  const rawData = {
    name: "",
    email: "",
    contact_no: "",
    seller_id: decode?.data?.user?.seller_id,
    role_id: "",
    status: false,
  };
  const errorRawData = {
    name: false,
    email: false,
    contact_no: false,
    role_id: false,
  };
  const [userData, setUserData]: any = useState(rawData);
  const [userDataError, setUserDataError]: any = useState(errorRawData);

  const inputHandler = (e: any) => {
    const { name, value } = e.target;
    // Phone field: keep digits only, cap at 10
    const newValue = name === "contact_no" ? value.replace(/\D/g, "").slice(0, 10) : value;
    setUserData({ ...userData, [name]: newValue });
  };
  const errorHandler = (e: any) => {
    const { name, value } = e.target;
    if (!value) {
      setUserDataError({ ...userDataError, [name]: true });
    } else if (name === "email" && !EMAIL_REGEX.test(value.trim())) {
      setUserDataError({ ...userDataError, [name]: EMAIL_ERROR_MSG });
    } else if (name === "contact_no" && !PHONE_REGEX.test(value.trim())) {
      setUserDataError({ ...userDataError, [name]: PHONE_ERROR_MSG });
    } else {
      setUserDataError({ ...userDataError, [name]: "valid" });
    }
  }
  const getRole = async () => {
    try {
      const { data } = await axios({
        url: `${apiEndpoint}/getrolelist`,
        method: "POST",
        headers: {
          "x-custom-authorization": `Bearer ${sessionStorage.getItem("us_st_d")}`,
        },
        data: {
          seller_id: decode?.data?.user?.seller_id,
        },
      });
      // console.log("role listing", data);
      if (data.status === 200) {
        setRoleData(data.data);
      }
    } catch (error) { }
  };
  const newUserCreatehandler = async () => {
    setLoading(true);
    console.log(userData);
    try {
      const {
        name,
        email,
        contact_no,
        role_id,
      } = userData;
      if (email && !EMAIL_REGEX.test(String(email).trim())) {
        toast.error(EMAIL_ERROR_MSG, { position: "top-right", autoClose: 5000 });
        setUserDataError({ ...userDataError, email: EMAIL_ERROR_MSG });
        setLoading(false);
        return;
      }
      if (contact_no && !PHONE_REGEX.test(String(contact_no).trim())) {
        toast.error(PHONE_ERROR_MSG, { position: "top-right", autoClose: 5000 });
        setUserDataError({ ...userDataError, contact_no: PHONE_ERROR_MSG });
        setLoading(false);
        return;
      }
      if (name && email && contact_no && role_id) {
        const { data } = await axios({
          url: `${apiEndpoint}/userregister`,
          method: "POST",
          headers: {
            "x-custom-authorization": `Bearer ${sessionStorage.getItem("us_st_d")}`,
          },
          data: userData,
        });
        if (data.message === "flag2") {
          toast.error("Email already exist", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
          setUserData(rawData);
        } else if (data.message === "flag1") {
          toast.success("User created successfully", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        } else if (data.message === "flag3") {
          data.data.map((irm: any) => {
            toast.error(irm, {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          });

        }
      } else {
        toast.error("Please fill all the fields !", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      toast.error("404 error !", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  };

  useEffect(() => {
    getRole();
  }, []);
  return (
    <>
      <ThemeMaker>
        <div className={`${brandStyles.pageWrap} mcrb-page`}>
          <div className={`${brandStyles.cardOuter} mcrb-card`}>
            <div className={brandStyles.headerBar}>
              <span className={brandStyles.title}>Add a New User</span>
            </div>
            <div className={brandStyles.bodyArea} style={{ minHeight: "60vh" }}>
              <div className="row">
                <div className="col-md-6">
                  <div className={brandStyles.field}>
                    <label className={brandStyles.label}>Name<span className={brandStyles.required}>*</span>
                      {
                        userDataError?.name !== "valid" && userDataError?.name !== false ? (
                          <span className={brandStyles.errorInline}>This field is required !</span>
                        ) : null
                      }
                    </label>
                    <input
                      type="text"
                      className={brandStyles.input}
                      name="name"
                      placeholder="Enter name"
                      value={userData.name}
                      onChange={(e) => inputHandler(e)}
                      onBlur={(e) => errorHandler(e)}
                    />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className={brandStyles.field}>
                    <label className={brandStyles.label}>Email address<span className={brandStyles.required}>*</span>
                      {
                        userDataError?.email !== "valid" && userDataError?.email !== false ? (
                          <span className={brandStyles.errorInline}>{userDataError?.email === true ? "This field is required !" : userDataError?.email}</span>
                        ) : null
                      }
                    </label>
                    <input
                      type="text"
                      name="email"
                      className={brandStyles.input}
                      placeholder="Enter email"
                      value={userData.email}
                      onChange={(e) => inputHandler(e)}
                      onBlur={(e) => errorHandler(e)}
                    />
                  </div>
                </div>

                <div className="col-md-6">
                  <div className={brandStyles.field}>
                    <label className={brandStyles.label}>Contact<span className={brandStyles.required}>*</span>
                      {
                        userDataError?.contact_no !== "valid" && userDataError?.contact_no !== false ? (
                          <span className={brandStyles.errorInline}>{userDataError?.contact_no === true ? "This field is required !" : userDataError?.contact_no}</span>
                        ) : null
                      }
                    </label>
                    <input
                      type="text"
                      inputMode="numeric"
                      maxLength={10}
                      name="contact_no"
                      className={brandStyles.input}
                      placeholder="Enter contact"
                      value={userData.contact_no}
                      onChange={(e) => inputHandler(e)}
                      onBlur={(e) => errorHandler(e)}
                    />
                  </div>
                </div>

                <div className="col-md-6">
                  <div className={brandStyles.field}>
                    <label className={brandStyles.label}>Role<span className={brandStyles.required}>*</span>
                      {
                        userDataError?.role_id !== "valid" && userDataError?.role_id !== false ? (
                          <span className={brandStyles.errorInline}>This field is required !</span>
                        ) : null
                      }
                    </label>
                    <select
                      name="role_id"
                      className={brandStyles.input}
                      id=""
                      onChange={(e) => inputHandler(e)}
                      onBlur={(e) => errorHandler(e)}
                    >
                      <option value="">Select role</option>
                      {roleData
                        .filter((roleData: any) => {
                          if (roleData.status) {
                            return roleData;
                          }
                        })
                        .map((item: any) => (
                          <option value={item?.id}>
                            {" "}
                            {item?.role_name}{" "}
                          </option>
                        ))}
                    </select>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className={brandStyles.field}>
                    <label className={brandStyles.label}>Status</label>
                    <div className={brandStyles.statusRow}>
                      <input
                        type="checkbox"
                        className={brandStyles.checkbox}
                        checked={userData.status}
                        onChange={(e) =>
                          setUserData({ ...userData, status: !userData.status })
                        }
                      />
                      <span style={{ fontSize: "13px", color: "#6B7280", fontWeight: 600 }}>
                        {userData.status ? "Active" : "Inactive"}
                      </span>
                    </div>
                  </div>
                </div>

                <div className="col-md-12">
                  <button type="submit" className={brandStyles.saveBtn} disabled={loading} onClick={newUserCreatehandler}>
                    {loading ? "Saving..." : "Save"}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ThemeMaker>
    </>
  );
};

export default AddUser;
